import Grid from '@mui/material/Grid';
import { useSelector } from 'react-redux';

import CheckDouble from '@gef-ui/material-icons/CheckDouble';
import ClockFive from '@gef-ui/material-icons/ClockFive';
import TriangleExclamation from '@gef-ui/material-icons/TriangleExclamation';

import { getTasksAndInformation } from 'features/views/dashboard/tasksAndInformation/selectors';

import StatusIndicator from './StatusIndicator';

export const StatusOverview = () => {
	const { inDeadline = 0, nearingDeadline = 0, afterDeadline = 0 } = useSelector(getTasksAndInformation);

	return (
		<Grid container>
			<Grid textAlign="center" size={4}>
				<StatusIndicator icon={<CheckDouble />} color="success.main" value={inDeadline} />
			</Grid>
			<Grid textAlign="center" size={4}>
				<StatusIndicator icon={<ClockFive />} color="warning.main" value={nearingDeadline} />
			</Grid>
			<Grid textAlign="center" size={4}>
				<StatusIndicator icon={<TriangleExclamation />} color="error.main" value={afterDeadline} />
			</Grid>
		</Grid>
	);
};

export default StatusOverview;
